import { Calendar, MessageCircle } from "lucide-react";
import { openWhatsapp, openAgendar } from "@/lib/contact";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative overflow-hidden bg-[var(--uma-cream)] grain"
        >
            {/* Soft gold glow */}
            <div
                aria-hidden
                className="absolute -top-40 right-1/2 translate-x-[40%] w-[720px] h-[720px] rounded-full opacity-25 blur-3xl pointer-events-none"
                style={{
                    background:
                        "radial-gradient(circle, rgba(197,160,89,0.45), transparent 60%)",
                }}
            />

            {/* Subtle dashed decorative box behind headline (like reference) */}
            <div
                aria-hidden
                className="absolute inset-0 flex items-center justify-center pointer-events-none"
            >
                <div className="hidden md:block w-[640px] h-[360px] rounded-3xl border border-[var(--uma-forest)]/6 mt-[20px]" />
            </div>

            <div className="relative max-w-5xl mx-auto px-5 md:px-10 pt-20 md:pt-28 pb-16 md:pb-24 text-center">
                <div className="reveal">
                    <div className="uma-eyebrow justify-center">
                        Estudio Contable · Rocha, Uruguay
                    </div>
                </div>

                <h1
                    data-testid="hero-headline"
                    className="reveal font-serif-display text-[52px] sm:text-[72px] md:text-[92px] lg:text-[110px] text-[var(--uma-forest)] mt-7 md:mt-9"
                >
                    Contabilidad
                    <br />
                    que mira hacia
                    <br />
                    <em className="font-serif-display italic font-light" style={{ color: "#A98D2C" }}>
                        adelante
                    </em>
                </h1>

                {/* Gold underline */}
                <div className="reveal flex justify-center mt-7 md:mt-9">
                    <span className="block h-[3px] w-[80px] bg-[var(--uma-gold-cta)] rounded-full" />
                </div>

                <p
                    data-testid="hero-subheadline"
                    className="reveal mt-8 md:mt-10 max-w-2xl mx-auto text-[16px] md:text-[18px] leading-relaxed text-[var(--uma-text-soft)] font-light"
                >
                    Detrás de cada número hay información valiosa para tu
                    negocio. La trabajamos para que estés siempre un paso
                    adelante: sin sorpresas fiscales, sin inspecciones
                    inesperadas, con claridad para crecer.
                </p>

                <div className="reveal mt-10 md:mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
                    <button
                        data-testid="hero-cta-primary"
                        onClick={() => openAgendar()}
                        className="group inline-flex items-center justify-center gap-2 bg-[var(--uma-gold-cta)] text-[var(--uma-forest)] hover:bg-[var(--uma-gold-cta-hover)] px-8 py-4 rounded-md font-medium transition-all hover:-translate-y-0.5 hover:shadow-[0_12px_30px_rgba(230,180,28,0.35)]"
                    >
                        <Calendar className="h-4 w-4" />
                        Agenda una consulta gratis
                    </button>
                    <button
                        data-testid="hero-cta-whatsapp"
                        onClick={() =>
                            openWhatsapp(
                                "Hola Estela, vengo del sitio. Quisiera consultar por sus servicios.",
                            )
                        }
                        className="group inline-flex items-center justify-center gap-2 border border-[var(--uma-gold-cta)]/40 text-[var(--uma-forest)] hover:bg-[var(--uma-cream-soft)] px-8 py-4 rounded-md font-medium transition-all"
                    >
                        <MessageCircle className="h-4 w-4" />
                        WhatsApp
                    </button>
                </div>
            </div>

            {/* Trust bar — separated white-ish strip */}
            <div
                data-testid="hero-trust-bar"
                className="relative bg-[var(--uma-cream-white)] border-t border-b border-[var(--uma-forest)]/8"
            >
                <div className="max-w-5xl mx-auto px-5 md:px-10 py-8 md:py-10 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0">
                    {[
                        { k: "Presencia local", v: "Rocha y Castillos" },
                        { k: "Contabilidad preventiva", v: "No reactiva" },
                        { k: "Primera consulta", v: "Sin costo" },
                    ].map((t, i) => (
                        <div
                            key={i}
                            data-testid={`hero-trust-${i}`}
                            className={`px-4 md:px-8 ${i > 0 ? "md:border-l border-[var(--uma-forest)]/12" : ""}`}
                        >
                            <div className="text-[12px] uppercase tracking-[0.2em] text-[var(--uma-text-soft)] font-medium">
                                {t.k}
                            </div>
                            <div className="mt-2 text-[16px] md:text-[17px] font-medium text-[var(--uma-text)]">
                                {t.v}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
